import React, { useState } from 'react';
import { Modal } from 'reactstrap';

import HandleImport from './HandleImport';

function ImportBlockedWhatsappNumbers(props) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {props.buttonOpenModal({
        onClick: () => setIsOpen(!isOpen)
      })}
      <Modal
        className="modal-dialog-centered"
        isOpen={isOpen}
        returnFocusAfterClose={false}
        unmountOnClose={true}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-default">
            Importar Números do WhatsApp Para Serem Bloqueados
          </h6>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <span aria-hidden={true}>&times;</span>
          </button>
        </div>
        <HandleImport isOpen={isOpen} setIsOpen={setIsOpen} />
      </Modal>
    </>
  );
}

export default ImportBlockedWhatsappNumbers;
